(function () {
  function setCollapsedState(text, collapsed) {
    text.classList.toggle('is-collapsed', collapsed);
  }

  function initReadMore(wrapper) {
    if (wrapper.dataset.readMoreInit) return;

    var text = wrapper.querySelector('.rich-text__text--collapsible');
    var button = wrapper.querySelector('.rich-text__read-more');
    var label = button && button.querySelector('.rich-text__read-more-label');
    if (!text || !button || !label) return;

    wrapper.dataset.readMoreInit = 'true';

    var readMore = wrapper.dataset.readMoreLabel || 'Read More +';
    var readLess = wrapper.dataset.readLessLabel || 'Read Less -';
    var expanded = false;

    function checkOverflow() {
      if (expanded) {
        button.hidden = false;
        return;
      }

      setCollapsedState(text, false);
      var fullHeight = text.scrollHeight;

      setCollapsedState(text, true);
      var overflowing = fullHeight > text.clientHeight + 1;
      button.hidden = !overflowing;

      if (!overflowing) {
        setCollapsedState(text, false);
      }
    }

    button.addEventListener('click', function () {
      expanded = !expanded;
      text.classList.toggle('is-expanded', expanded);
      setCollapsedState(text, !expanded);
      label.textContent = expanded ? readLess : readMore;
      button.setAttribute('aria-expanded', expanded);
      button.hidden = false;
    });

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
  }

  function init() {
    document.querySelectorAll('[data-read-more="rich-text"]').forEach(initReadMore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
